module.exports = __webpack_public_path__ + "img/withJdg.e4673395.png";